<template>
  <div>
    <div class="banner-header">
      <div>banner管理 / 操作</div>
      <div>
        <el-button @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" @click="submitForm(1)" v-if="isOperation"
          >草稿</el-button
        >
        <el-button type="primary" @click="submitForm(2)" v-if="isOperation"
          >发布</el-button
        >
      </div>
    </div>
    <div class="banner-main">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleFormRef"
        label-width="120px"
      >
        <el-form-item label="BANNER名称" prop="title">
          <el-input
            v-model="ruleForm.title"
            placeholder="banner名称不在app上显示，仅供后台管理参考"
            :disabled="!isOperation"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布日期">
          <el-date-picker
            v-model="ruleForm.daterange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled="!isOperation"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
            v-model="ruleForm.orderNum"
            :min="1"
            :max="5"
            :disabled="!isOperation"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="位置类型" prop="positionType">
          <el-select
            v-model="ruleForm.positionType"
            placeholder="请选择"
            style="width: 100%"
            :disabled="!isOperation"
          >
            <el-option label="3.0.0版本之前的发现频道" :value="1"></el-option>
            <el-option label="跑步记录顶部" :value="2"></el-option>
            <el-option label="运动音乐顶部" :value="3"></el-option>
            <el-option label="首页-为你推荐" :value="4"></el-option>
            <el-option label="社区-动态" :value="5"></el-option>
            <el-option label="3.0.0版本及之后的发现频道" :value="6"></el-option>
            <el-option label="问卷调查" :value="7"></el-option>
            <el-option label="首页BANNER" :value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="BANNER图" prop="bannerImage">
          <UploadItems
            :urls="ruleForm.bannerImage"
            actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=8"
            @onUrls="onUrls"
            :readonly="!isOperation"
          />
          <div class="upload__tip" v-if="ruleForm.positionType == 1">
            建议：尺寸750 * 418，格式为jpg、png
          </div>
          <div class="upload__tip" v-if="ruleForm.positionType == 2">
            建议：尺寸750 * 270，格式为jpg、png
          </div>
          <div class="upload__tip" v-if="ruleForm.positionType == 3">
            建议：尺寸750 * 270，格式为jpg、png
          </div>
          <div class="upload__tip" v-if="ruleForm.positionType == 4">
            建议：尺寸584 * 240，格式为jpg、png
          </div>
          <div class="upload__tip" v-if="ruleForm.positionType == 5">
            建议：尺寸686 * 240，格式为jpg、png
          </div>
          <div class="upload__tip" v-if="ruleForm.positionType == 6">
            建议：尺寸686 * 240，格式为jpg、png
          </div>
          <div class="upload__tip" v-if="ruleForm.positionType == 7">
            建议：尺寸750 * 270，格式为jpg、png
          </div>
        </el-form-item>
        <el-form-item label="点击资源" prop="type">
          <el-select
            v-model="ruleForm.type"
            placeholder="请选择"
            style="width: 100%"
            :disabled="!isOperation"
          >
            <el-option label="无跳转" :value="-1"></el-option>
            <el-option label="跳转至已有文章" :value="1"></el-option>
            <el-option label="跳转至已有话题" :value="2"></el-option>
            <el-option label="跳转至URL" :value="5"></el-option>
            <el-option label="跳转至已有活动" :value="6"></el-option>
            <el-option label="跳转至微信小程序" :value="7"></el-option>
            <el-option label="跳转至音频" :value="8"></el-option>
            <el-option label="跳转至支付宝小程序" :value="9"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="ruleForm.type === 1 ? '文章ID' : '话题ID'"
          v-if="[1, 2].includes(ruleForm.type)"
          prop="targetId"
        >
          <el-input
            v-model="ruleForm.targetId"
            :disabled="!isOperation"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="ruleForm.type === 5 ? 'H5' : '活动链接'"
          v-if="[5, 6].includes(ruleForm.type)"
          prop="targetUrl"
        >
          <el-input
            v-model="ruleForm.targetUrl"
            :disabled="!isOperation"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="小程序原始ID"
          v-if="ruleForm.type === 7 || ruleForm.type === 9"
          prop="miniId"
        >
          <el-input
            v-model="ruleForm.miniId"
            :disabled="!isOperation"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="小程序路径"
          v-if="ruleForm.type === 7 || ruleForm.type === 9"
          prop="miniPath"
        >
          <el-input
            v-model="ruleForm.miniPath"
            :disabled="!isOperation"
          ></el-input>
        </el-form-item>

        <template v-if="ruleForm.type === 8">
          <el-form-item label="专辑ID" prop="audioID">
            <el-input
              v-model="ruleForm.audioID"
              :disabled="!isOperation"
            ></el-input>
          </el-form-item>
          <el-form-item label="主播名称" prop="audioNickName">
            <el-input
              v-model="ruleForm.audioNickName"
              :disabled="!isOperation"
            ></el-input>
          </el-form-item>
          <el-form-item label="单曲数">
            <el-input-number
              v-model="ruleForm.audioCount"
              :min="0"
              :disabled="!isOperation"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="是否付费">
            <el-radio-group
              v-model="ruleForm.audioIsPaid"
              style="display: flex; line-height: 36px"
              :disabled="!isOperation"
            >
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>

        <el-form-item label="学校">
          <el-radio-group
            v-model="ruleForm.applicableCampus"
            style="display: flex; line-height: 36px"
            @change="bindRadioChange"
          >
            <el-radio :label="0" :disabled="!isOperation">全部</el-radio>
            <el-radio :label="1" :disabled="!isOperation">部分</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          :label="ruleForm.applicableCampus ? '应用学校' : '屏蔽学校'"
          :required="ruleForm.applicableCampus ? true : false"
          prop="rootUnids"
        >
          <div style="display: flex; align-items: center">
            <el-select
              v-model="schoolData"
              placeholder="请选择学校"
              filterable
              style="flex: 1; margin-right: 8px"
              :disabled="!isOperation"
            >
              <el-option
                v-for="(item, index) in schoolDataSource"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button @click="onAddSchools" :disabled="!isOperation"
              >添加</el-button
            >
          </div>
          <div class="card-wrap">
            <div
              v-for="item in ruleForm.rootUnids"
              :key="item.value"
              class="dialog-item"
            >
              <span>{{ item.label }}</span>
              <el-button
                type="text"
                icon="circle-close"
                @click="onDelSchools(item.value)"
              ></el-button>
            </div>
          </div>
          <div class="card-footer">
            共计{{ ruleForm.rootUnids.length }}所学校
          </div>
        </el-form-item>
        <el-form-item label="广告曝光代码">
          <el-input
            type="textarea"
            v-model="ruleForm.adExposingCodes"
            :autosize="{ minRows: 5 }"
            :disabled="!isOperation"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import UploadItems from "../../UploadItems/index.vue";
export default {
  components: { UploadItems },
  data() {
    const validateSchool = (rule, value, callback) => {
      if (this.ruleForm.applicableCampus && (!value || !value.length)) {
        return callback(new Error("学校不能为空"));
      }
      callback();
    };
    return {
      id: "",
      isOperation: true, // 是否可操作
      hasQuery: false, // 是否有网络请求
      ruleForm: {
        title: "", // banner名称
        orderNum: 1,
        positionType: null,
        bannerImage: "",
        applicableCampus: 0,
        rootUnids: [],
        type: null,
        adExposingCodes: "",
        targetId: "",
        targetUrl: "",
        miniId: "", // 小程序ID
        miniPath: "", // 小程序路径
        audioID: "", // 专辑ID
        audioNickName: "", // 主播名称
        audioCount: 0, // 单曲数
        audioIsPaid: 0, // 是否付费
        daterange: [], // 日期
      },
      rules: {
        title: { required: true, message: "请输入名称", trigger: "blur" },
        positionType: {
          type: "number",
          required: true,
          message: "请选择位置类型",
          trigger: "change",
        },
        bannerImage: {
          required: true,
          message: "请上传BANNER",
          trigger: "change",
        },
        type: {
          type: "number",
          required: true,
          message: "请选择方式",
          trigger: "change",
        },
        miniId: {
          required: true,
          message: "请输入小程序ID",
          trigger: "blur",
        },
        miniPath: {
          required: true,
          message: "请输入小程序路径",
          trigger: "blur",
        },
        targetId: {
          required: true,
          message: "请输入",
          trigger: "blur",
        },
        targetUrl: {
          required: true,
          message: "请输入",
          trigger: "blur",
        },
        audioID: { required: true, message: "请输入专辑ID", trigger: "blur" },
        audioNickName: {
          required: true,
          message: "请输入主播名称",
          trigger: "blur",
        },
        rootUnids: {
          validator: validateSchool,
          trigger: "change",
        },
      },
      schoolDataSource: [],
      schoolData: "",
    };
  },
  created() {
    if (this.$route.query.type === "detail") {
      this.isOperation = false;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
  },
  mounted() {
    this.apiGetALLSchool();
    if (this.$route.query.id) {
      this.apiPostBannerDetail();
    }
  },
  methods: {
    apiGetALLSchool() {
      this.$http({
        url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
        method: "GET",
      })
        .then((res) => {
          if (res.body.data && res.body.data.length) {
            this.schoolDataSource = res.body.data.map((item) => ({
              label: item.name,
              value: item.rootUnid,
            }));
          } else {
            this.schoolDataSource = [];
          }
        })
        .catch((error) => {
          this.schoolDataSource = [];
        });
    },
    getUrlParam(name, data) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = data.targetUrl.match(reg);
      if (r != null) {
        return r[2];
      }
      return null;
    },
    apiPostBannerDetail() {
      this.$http({
        url: this.$util.domain + "/adminapi/v3/operate/banner/details",
        method: "POST",
        dataType: "json",
        body: JSON.stringify({
          id: this.id,
        }),
      })
        .then((res) => {
          if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
            let miniId = "";
            let miniPath = "";
            let audioID = "";
            let audioNickName = "";
            let audioCount = 0;
            let audioIsPaid = 0;
            if (res.body.data.type === 7) {
              miniId = this.getUrlParam("id", res.body.data);
              miniPath = this.getUrlParam("path", res.body.data);
            } else if (res.body.data.type === 8) {
              audioID = this.getUrlParam("id", res.body.data);
              audioNickName = this.getUrlParam("nickName", res.body.data);
              audioCount = this.getUrlParam("count", res.body.data) * 1 || 0;
              audioIsPaid = this.getUrlParam("isPaid", res.body.data) * 1 || 0;
            } else if (res.body.data.type === 9) {
              miniId = this.getUrlParam("appId", res.body.data);
              miniPath = this.getUrlParam("page", res.body.data);
            }

            const {
              title,
              orderNum,
              positionType,
              imgUrl,
              applicableCampus,
              campusList,
              type,
              adExposingCodes,
              targetId,
              targetUrl,
              beginAt,
              endAt,
            } = res.body.data;
            
            this.hasQuery = true

            this.ruleForm = {
              title, // banner名称
              orderNum,
              positionType,
              bannerImage: imgUrl,
              applicableCampus,
              rootUnids: campusList.map((item) => ({
                label: item.name,
                value: item.rootUnid,
              })),
              type,
              adExposingCodes,
              targetId: `${targetId}`,
              targetUrl,
              miniId, // 小程序ID
              miniPath, // 小程序路径
              audioID, // 专辑ID
              audioNickName, // 主播名称
              audioCount, // 单曲数
              audioIsPaid, // 是否付费
              daterange: [beginAt, endAt], // 日期
            };
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onUrls(bannerImage) {
      this.ruleForm.bannerImage = bannerImage;
    },
    bindRadioChange() {
      if (this.hasQuery) { // 为了规避网络请求之后赋值applicableCampus时导致这个方法的调用
        this.hasQuery = false
        return
      }
      this.schoolData = null;
      this.ruleForm.rootUnids = [];
    },
    onAddSchools() {
      const datad = this.ruleForm.rootUnids.find((item) => {
        return item.value === this.schoolData;
      });
      if (datad && JSON.stringify(datad) !== "{}") {
        this.schoolData = null;
        return;
      }
      const data = this.schoolDataSource.find((item) => {
        return item.value === this.schoolData;
      });
      if (data && JSON.stringify(data) !== "{}") {
        this.ruleForm.rootUnids = [...this.ruleForm.rootUnids, data];
        this.schoolData = "";
      }
    },
    onDelSchools(unid) {
      const index = this.ruleForm.rootUnids
        .map((item) => item.value)
        .indexOf(unid);
      this.ruleForm.rootUnids.splice(index, 1);
    },
    submitForm(bannerStatus) {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          const {
            miniId,
            miniPath,
            audioID,
            audioNickName,
            audioCount,
            audioIsPaid,
            daterange,
            ...param
          } = this.ruleForm;

          let targetUrl = this.ruleForm.targetUrl;
          let targetId = this.ruleForm.targetId;
          let rootUnids = [];

          if ([1, 2].includes(this.ruleForm.type)) {
            targetUrl = "";
          } else if ([5, 6].includes(this.ruleForm.type)) {
            targetId = "";
          }
          if (this.ruleForm.type === 7) {
            targetUrl = `id=${miniId.trim()}&path=${miniPath.trim()}`;
            targetId = "";
          } else if (this.ruleForm.type === 8) {
            targetUrl = `id=${audioID.trim()}&nickName=${audioNickName.trim()}&count=${audioCount}&isPaid=${audioIsPaid}`;
            targetId = "";
          } else if (this.ruleForm.type === 9) {
            targetUrl = `appId=${miniId.trim()}&page=${miniPath.trim()}`;
            targetId = "";
          }

          if (this.ruleForm.rootUnids && this.ruleForm.rootUnids.length) {
            rootUnids = this.ruleForm.rootUnids.map((item) => item.value);
          }

          const params = {
            ...param,
            targetUrl,
            targetId,
            rootUnids,
            bannerStatus,
            beginAt: daterange[0] ? new Date(daterange[0]).getTime() : "",
            endAt: daterange[1] ? new Date(daterange[1]).getTime() : "",
          };

          this.$http({
            url: this.$util.domain + "/adminapi/v3/operate/banner/add",
            method: "POST",
            dataType: "json",
            body: JSON.stringify({
              ...params,
            }),
          }).then((res) => {
            if (res.body.error === 10000) {
              this.$router.go(-1);
            } else {
              this.$util.errorMsg(res.body.message);
            }
          });
        } else {
          this.$util.errorMsg("请重试");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.banner-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  background-color: #eee;
  font-size: 16px;
  padding: 8px 30px;
  margin-top: 20px;
}
.banner-main {
  box-sizing: border-box;
  width: 640px;
  padding: 20px;
}
.card-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 200px;
  overflow: auto;
  padding: 10px;
  margin: 8px 0 4px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
}
.card-footer {
  text-align: right;
  font-size: 14px;
  line-height: 1.5;
}
.upload__tip {
  font-size: 12px;
  line-height: 1.5;
}
.dialog-item {
  display: inline-block;
  margin: 0 4px 4px;
  padding: 4px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// bannerDetail.vue?19cf9202